export default __webpack_public_path__ + "static/media/Logo.bf66beee.svg";